/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon20Light = forwardRef('ArrowDim2DiagMaxRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12 2a.5.5 0 0 0 0 1h4.293l-5.147 5.146a.5.5 0 0 0 .708.708L17 3.707V8a.5.5 0 0 0 1 0V3.5A1.5 1.5 0 0 0 16.5 2H12Z" }),
        React.createElement("path", { d: "M8.854 11.146a.5.5 0 0 0-.708 0L3 16.293V12a.5.5 0 0 0-1 0v4.5A1.5 1.5 0 0 0 3.5 18H8a.5.5 0 0 0 0-1H3.707l5.147-5.146a.5.5 0 0 0 0-.708Z" })));
});
